export function isMobile() {
    const ua = navigator.userAgent;
    const isMobile = /Mobile|Android|iP(hone|od|ad)|IEMobile|Opera Mini/i.test(ua);
    return isMobile;
}
